/* import __COLOCATED_TEMPLATE__ from './undo-button.hbs'; */
/* RESPONSIBLE TEAM: team-proactive-support */
import Component from '@glimmer/component';
import { action } from '@ember/object';
import type Graph from '../../../models/graph-editor/graph';

interface Args {
  graph: Graph;
}

export default class GraphEditorControlsUndoButtonComponent extends Component<Args> {
  @action undoEdit(): void {
    if (this.args.graph.actionsToUndo.length && !this.args.graph.recordingActions) {
      this.args.graph.undoAction();
    }
  }
}
